/**
 * Date utilities
 */

/**
 * Returns a new Date set to the start of the day (00:00:00.000) for
 * day-level comparisons. Does not mutate the input.
 */
export const normalizeToStartOfDay = (date: Date): Date => {
    const d = new Date(date);
    d.setHours(0, 0, 0, 0);
    return d;
};

export const dateWithAppendedHours = (date: string, hours = 1): string => {
    return new Date(
        new Date(date).getTime() + hours * 60 * 60 * 1000,
    ).toLocaleString();
};
